export enum PROJECT {
	ADMIN = 'admin',
	ADMIN_V2 = 'admin_v2',
	INVESTOR = 'investor',
	GODMODE = 'godmode',
}

export enum ENVIRONMENT_CATEGORY {
	PRODUCTION = 'production',
	STAGING = 'staging',
	LOCAL = 'local',
}

export enum EXACT_ENVIRONMENT {
	PRODUCTION = 'production',
	DEMO = 'demo',
	QA = 'QA',
	LOCAL = 'local',
}

/**
 * The environment that hosts and serves eID Easy custom-signature-image webhooks
 * on behalf of the ephemeral per-PR review envs (which share its eID Easy client
 * and S3 bucket). Review env hostnames live under `*.review.qa.dealstack-dev.com`.
 */
export const REVIEW_ENV_HOST_ENVIRONMENT = 'qa';

/**
 * True when the given public API URL belongs to an ephemeral per-PR review env.
 *
 * Review envs are served under the review wildcard domain
 * `*.review.<env>.dealstack-dev.com` (see the per-PR Terraform module's
 * `wildcard_domain`), e.g. `backend-pr-5306.review.qa.dealstack-dev.com`. This
 * excludes production, named long-lived envs (lisbon/…), qa, and localhost.
 */
export function isReviewEnvUrl(apiFrontendUrl: string): boolean {
	try {
		const { hostname } = new URL(apiFrontendUrl);
		return /\.review\.[^.]+\.dealstack-dev\.com$/.test(hostname);
	} catch {
		return false;
	}
}

const REVIEW_ENV_HOST_PATTERN = /(?:^|[-.])(pr-\d+)\./;

/** The `pr-<N>` identity in a review-env URL such as `backend-pr-123.review.qa.dealstack-dev.com`. */
export function getReviewEnvId(apiFrontendUrl: string): string | undefined {
	return apiFrontendUrl.match(REVIEW_ENV_HOST_PATTERN)?.[1];
}
